import { call, select } from 'redux-saga/effects';
import { getCurrentSubfolder, getCurrentGallection } from '../selectors';
import setGallectionCover from './setGallectionCover';
function* makeDeviationCurrentGallectionCover(action) {
    const deviation = action.payload;
    // if we're inside a subfolder, make sure we change the cover on that - not the parent
    const currentSubfolder = yield select(getCurrentSubfolder);
    const currentGallection = yield select(getCurrentGallection);
    const gallection = currentSubfolder || currentGallection;
    if (!gallection) {
        return;
    }
    yield call(setGallectionCover, {
        gallection,
        deviation
    });
}
export default makeDeviationCurrentGallectionCover;

//# sourceMappingURL=makeDeviationGallectionCover.js.map